<template>
  <div class="otherbox">
    <Other ref='Other' :info='OtherInfo'></Other>
    <!-- 关联被告信息 -->
    <div class="htit">
      <div class="h2">关联被告信息</div>
      <div class="rt">
        <a-button type="primary" icon="plus" @click='OtherInfo = {
          city: [debInfo.province, debInfo.city, debInfo.area],
          dwell: debInfo.dwell_province ? [debInfo.dwell_province, debInfo.dwell_city, debInfo.dwell_area] : [debInfo.province, debInfo.city, debInfo.area],
          dwell_addr: debInfo.dwell_addr,
          addr: debInfo.addr
        }; visibleShow("Other");'
          v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:other:add") && debInfo.is_clear != 1'>添加</a-button>
      </div>
    </div>
    <div class="tableList"
      v-if='debInfo.other_debtor && debInfo.other_debtor.length > 0 && $common.AccAUTH(debInfo.accuser_id, "debtor:other:index")'>
      <div class="table">
        <table>
          <thead>
            <td width='70'>姓名</td>
            <td width='80'>证件号码</td>
            <td width='60'>联系方式</td>
            <td width='35'>性别</td>
            <td width='50'>关系</td>
            <td width='152'>户籍地</td>
            <td width='152'>常住地</td>
            <td width='70'>操作</td>
          </thead>
          <tbody>
            <tr v-for='(i, index) in debInfo.other_debtor' :key='i.id'>
              <td>{{ i.realname }}</td>
              <td>{{ i.chinaid }}</td>
              <td>{{ i.phone }}</td>
              <td>{{ i.sex | tosex }}</td>
              <td> {{ i.relation | torelation }}</td>
              <td>
                <Normap :tit="i.province + i.city + (i.area || '') + (i.addr ? i.addr : '')"></Normap>
              </td>
              <td>
                <Normap
                  :tit="i.dwell_province ? (i.dwell_province + i.dwell_city + i.dwell_area + (i.dwell_addr ? i.dwell_addr : '')) : null">
                </Normap>
              </td>
              <td v-if='debInfo.is_clear != 1'>
                <a href="javascript:void(0);"
                  @click='OtherInfo = Object.assign({ see: true }, i); visibleShow("Other");'>查看</a>
                <span class="line" v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:other:edit")'></span>
                <a href="javascript:void(0);" @click='visibleShow("Other"); OtherInfo = i;'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:other:edit")'>修改</a>
                <span class="line" v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:other:del")'></span>
                <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='del(i.id)'
                  v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:other:del")'>
                  <a href="javascript:void(0);" style="color:#f00;" :disabled='i.audit.length > 0'
                    :class='{ "ising": i.audit.length > 0 }'>删除</a>
                </a-popconfirm>
              </td>
              <td v-else>/</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { delOther } from '@/server/debtor'
import Other from './other'
export default {
  components: { Other },
  name: 'OtherList',
  data() {
    return {
      OtherInfo: {}
    }
  },
  computed: {
    ...mapGetters([
      'debInfo',
    ])
  },
  methods: {
    del(id) {         //删除关联被告
      delOther({ id: id }).then(e => {
        this.$store.dispatch("Debinfo/getInfo", { id: this.$route.params.id })
        this.$message.success({ content: '已提交审核', key: 'updatable' });
      })
    },
    visibleShow(name) {
      this.$store.dispatch("openkey", { key: name, by: true })
    },
  }
}
</script>